import React, { createContext, useState, useContext } from 'react'

export const SelectedVehicleContext = createContext();

export const useSelectedVehicle = ()=> useContext(SelectedVehicleContext);

export const SelectedVehicleProvider = ({ children }) => {

    const initVehicle = {
            vehKey: null,
            variantKey: null,
            isSelected: false,
            selectingVariant: false,
            enabledFeatures: [],
            kills: {
                weapon: false,
                mobility: false,
                comms: false,
                total: false,

            }
    }

    const [selVehData, setSelVehData] = useState(initVehicle);

    const value = { selVehData, setSelVehData };
    return <SelectedVehicleContext.Provider value={value}>{children}</SelectedVehicleContext.Provider>
}